import React, { useState } from 'react';
import { Col, Container, Row } from "reactstrap"
import { useForm } from "react-hook-form";
import axios from 'axios';
import base64 from 'base-64'
import { useHistory } from "react-router-dom";
// import signupApi from '../services/signup';
import { BsFillLockFill, BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/css/Login.css'
import IdleMonitor from './userAutoLogout';
import ENV from '../env'; //session management

const ResetPwd = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)
    const [pswdIcon, setPswdIcon] = useState(false)
    const [pswdConIcon, setConPswdIcon] = useState(false)
    const [pswdTxt, setPswdTxt] = useState("password")
    const [pswdConTxt, setConPswdTxt] = useState("password")
    const [pswdNotMatch, setPswdNotMatch] = useState(false)
    // function notify() { toast.success("Successfully login!") };

    const { register, handleSubmit, formState: { errors } } = useForm();

    const resetPassword = (body) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
             console.log("res", res)
            let userId = JSON.parse(res[0]);
            let sToken = res[1];
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;
 
            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let apiUrl = `${ENV.LOCUSB_API}/UpdateUserPassword`
            axios.post(apiUrl, body, options)
                .then(response => {
                    if (response.data.success === "true") {
                        // console.log("API response", response.data.data)
                        toast.success("Reset password successfully!")
                        history.push('/')
                    } else {
                        if (response.data.errorMsg === "Invalid_SecureToken") {
                            history.push('/forget-pwd')
                            toast.error("Session expired, Please try again")
                            // console.log("Invalid secure token")
                        }
                        else console.log("something went wrong in load activities API")
                    }
                })

        }).catch((err) => {
            console.log("err", err)
        })
    }
    const onSubmit = data => {
        // console.log("data",data);
        setDisButton(true);
        if (data.passwd !== data.cpasswd) {
            setPswdNotMatch(true)
        }
        else {
            //api call
            // console.log("data", data);
            let reqBody = {
                userId: localStorage.getItem('userEmail'),
                passwd: data.passwd
            }
            console.log("reqBody",reqBody)
            resetPassword(reqBody);
        }
    }
    return (
        <div className="maindiv" style={{ fontFamily: "Poppins" }}>
            <Container fluid={true}>
                <Row className="align-content-center justify-content-center align-items-center parentrow">
                    <Col sm="12" md={{ size: 4, offset: 4 }}>
                        <div className="text-center bg-white middleDiv1">
                            <div className="innerDiv rounded">
                                <img src="LocusB.png" alt="logo" className="logo" />
                                <div className="text-center mb-1">
                                    <h5 className="margin-header"><b>Reset Password</b></h5>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="pb-2">
                                        {/* Password input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillLockFill /></span>
                                            </div>
                                            <input className="form-control pswd-input" type={pswdTxt} placeholder="Enter your new password" {...register("passwd", { maxLength: 20, minLength: 8, required: true })} />
                                            <div className="form-group input-group-postpend">
                                                <span className="form-group input-group-text icon-setting right-icons">
                                                    {pswdIcon ?
                                                        <BsFillEyeFill onClick={e => { setPswdIcon(false); setPswdTxt("password") }} /> :
                                                        <BsFillEyeSlashFill onClick={e => { setPswdIcon(true); setPswdTxt("text") }} />
                                                    }
                                                </span>
                                            </div>
                                            <span className="errorSpan2 mx-0">{errors.passwd?.type === 'required' && "*Password is required"}</span>
                                            <span className="errorSpan2 mx-0">{errors.passwd?.type === 'maxLength' && "*Password should contain at most 20 characters"}</span>
                                            <span className="errorSpan2 mx-0">{errors.passwd?.type === 'minLength' && "*Password should contain at least 8 characters"}</span>
                                        </div>

                                        {/* Confirm Password input field */}
                                        <div className="form-group input-group marginBottomErrorSpan">
                                            <div className="form-group input-group-prepend">
                                                <span className="form-group input-group-text icon-setting left-icons"><BsFillLockFill /></span>
                                            </div>
                                            <input className="form-control pswd-input" type={pswdConTxt} placeholder="Confirm your password" onFocus={() => { setPswdNotMatch(false); setDisButton(false); }} {...register("cpasswd", { required: true })} />
                                            <div className="form-group input-group-postpend">
                                                <span className="form-group input-group-text icon-setting right-icons">
                                                    {pswdConIcon ?
                                                        <BsFillEyeFill onClick={a => { setConPswdIcon(false); setConPswdTxt("password") }} /> :
                                                        <BsFillEyeSlashFill onClick={a => { setConPswdIcon(true); setConPswdTxt("text") }} />
                                                    }
                                                </span>
                                            </div>
                                            <span className="errorSpan2 mx-0">{errors.cpasswd?.type === 'required' && "*Confirm password is required"}</span>
                                            <span className="errorSpan2 mx-0">{pswdNotMatch && "*Password not matched"}</span>
                                        </div>

                                    </div>
                                    <ToastContainer />
                                    <div className="btn-margin">
                                        <button type="submit" disabled={disButton} className="btnDesg mb-2">
                                            {(disButton && !pswdNotMatch) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Submit"}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Col>
                    <Col md={4} />
                </Row>
            </Container>
            <IdleMonitor/>
        </div>
    );
}

export default ResetPwd;
